import { useMemo } from 'react';
import { useRouter } from 'next/router';
import CompactFooter from './CompactFooter';
import ExtendedFooter from './ExtendedFooter';
import { ACCESSORIES_ROUTE } from '@/lib/purchase-flow';

export default function Footer() {
  const { pathname } = useRouter();

  const isCompactFooter = useMemo(
    () =>
      ['/checkout/[checkoutId]', '/cart', ACCESSORIES_ROUTE].includes(pathname),
    [pathname],
  );

  if (isCompactFooter) {
    return <CompactFooter />;
  }

  return <ExtendedFooter />;
}
